import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {useIntl} from 'react-intl'
import clsx from 'clsx'
import {apiGetUsers} from '../../../redux/api'
import UsersListTable from './components/UsersListTable'

function UsersListPage() {
  const intl = useIntl()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [itemsPerPage, setItemsPerPage] = useState<number>(10)
  const [usersList, setUsersList] = useState<any>([])
  const [pageCount, setPageCount] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [offset, setOffset] = useState<number>(1)
  const getUsers = (offset = 1, itemsPerPage: number) => {
    const query: any = {
      limit: itemsPerPage,
      offset,
    }

    const data: any = {
      Action: 'VIEW',
    }

    setUsersList([])
    setIsLoading(true)
    apiGetUsers(query, data)
      .then(({data}: any) => {
        if (data.status === 200) {
          const totalPages = Math.ceil(data.response.TotalResults / data.response.PageSize)
          setUsersList(data.response.Results || [])
          setPageCount(totalPages)
          setCurrentPage(offset - 1)
        } else {
          setUsersList([])
          toast.error(intl.formatMessage({id: 'TOAST.ERROR_WHILE_REQUESTING_USERS_LIST'}))
        }
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
        setUsersList([])
        toast.error(intl.formatMessage({id: 'TOAST.ERROR_WHILE_REQUESTING_USERS_LIST'}))
      })
  }

  useEffect(() => {
    if (offset >= 0 && itemsPerPage > 0) {
      getUsers(offset, itemsPerPage)
    }
  }, [offset, itemsPerPage])

  const handlePageClick = (event: {selected: number}) => {
    const selectedPage = event.selected + 1
    getUsers(selectedPage, itemsPerPage)
  }

  return (
    <React.Fragment>
      <div className={`card`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-10'>
          <h1 className='align-items-start d-flex flex-column'>
            <span className='card-label fw-bolder text-primary mb-5'>
              {intl.formatMessage({id: 'MENU.USERS'})}
            </span>
          </h1>

          {!isLoading && usersList && usersList.length > 0 && (
            <div className='d-flex grow w-100 align-items-center'>
              <div className='d-flex position-relative my-1 ml-auto'>
                <ul className='pagination ml-8'>
                  <li className={clsx('page-item', {active: itemsPerPage == 10})}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(10)
                      }}
                      aria-label='10'
                    >
                      10
                    </button>
                  </li>
                  <li className={clsx('page-item', {active: itemsPerPage == 25})}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(25)
                      }}
                      aria-label='25'
                    >
                      25
                    </button>
                  </li>
                  <li className={clsx('page-item', {active: itemsPerPage == 50})}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(50)
                      }}
                      aria-label='50'
                    >
                      50
                    </button>
                  </li>
                  <li className={clsx('page-item', {active: itemsPerPage == 100})}>
                    <button
                      type='button'
                      className='page-link'
                      onClick={(e) => {
                        setItemsPerPage(100)
                      }}
                      aria-label='100'
                    >
                      100
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
        {!isLoading && usersList && usersList.length > 0 && (
          <UsersListTable
            usersList={usersList}
            currentPage={currentPage}
            pageCount={pageCount}
            getUsers={getUsers}
            handlePageClick={handlePageClick}
            isLoading={isLoading}
            itemsPerPage={itemsPerPage}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default UsersListPage
